module.exports = __webpack_public_path__ + "img/18.f25ee816.png";